import React from 'react';
import {getMixLottoList, getQuickMixLottoList} from '../result-service';
import {MixLottoListItem} from '../result.type';
import {StyleSheet, View, ScrollView} from 'react-native';
import Spin from '@/components/basic/spin';
import theme from '@/style';
import {goTo} from '@/utils';
import NoData from '@/components/basic/error-pages/no-data';
import LotteryCard from './lottery-card';

const StateLottery = ({isActive}: {isActive?: boolean}) => {
  const [loading, setLoading] = React.useState(false);
  const [firstLoad, setFirstLoad] = React.useState(true);
  const [list, setList] = React.useState<MixLottoListItem[]>([]);
  const [quick, setQuick] = React.useState<MixLottoListItem[]>([]);
  const requestRef = React.useRef(0);
  const scrollRef = React.useRef<ScrollView>(null);

  const getList = async () => {
    const requestId = ++requestRef.current;
    try {
      setLoading(true);
      const [quickList, normalList] = await Promise.all([
        getQuickMixLottoList().catch(() => []),
        getMixLottoList().catch(() => []),
      ]);
      if (requestId !== requestRef.current) {
        return;
      }
      setQuick(quickList || []);
      setList(normalList || []);
    } finally {
      if (requestId === requestRef.current) {
        setLoading(false);
        setFirstLoad(false);
      }
    }
  };

  React.useEffect(() => {
    if (isActive) {
      setFirstLoad(true);
      setList([]);
      setQuick([]);
      scrollRef.current?.scrollTo({y: 0, animated: false});
      getList().then();
    } else {
      requestRef.current += 1;
    }
  }, [isActive]);

  const target = React.useMemo(() => {
    return quick.concat(list);
  }, [quick, list]);

  return (
    <Spin
      loading={loading}
      style={[theme.flex.flex1, theme.background.lightGrey]}>
      <ScrollView
        ref={scrollRef}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={[
          styles.contentContainer,
          !loading && target.length === 0 && styles.emptyContent,
        ]}>
        {target.length > 0 ? (
          target.map(item => {
            return (
              <LotteryCard
                key={`${item.isQuick ? 'quick' : 'state'}-${item.lotteryID}`}
                onPress={() => {
                  goTo('MixLotteryDetail', {
                    name: item.lotteryName,
                    lotteryID: item.lotteryID,
                    isQuick: item.isQuick ? '1' : '0',
                    filterList: JSON.stringify(target),
                  });
                }}
                item={item}
              />
            );
          })
        ) : !firstLoad && !loading ? (
          <View style={styles.emptyWrap}>
            <NoData />
          </View>
        ) : null}
      </ScrollView>
    </Spin>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    padding: 12,
    gap: 9,
    paddingBottom: 72,
  },
  emptyContent: {
    flexGrow: 1,
  },
  emptyWrap: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 360,
  },
});

export default StateLottery;
